import { ProductDetailViewModel, ProductSearchViewModel } from '@models/api-search.models';
import { BasketCalculatedLineViewModel } from '@models/api-orders.models';
import { ReserveProductDetail } from '@features/reserve-in-store/reserve-in-store';

export type ReserveInStoreLine = {
    reserved_item_id: string;
    reserved_item_name: string;
    reserved_item_quantity: number;
    reserved_price: number;
};

export type ReserveInStore = {
    reserved_items: ReserveInStoreLine[];
    store: string;
};

export type ReserveInStoreProducts = Partial<
    ProductSearchViewModel | ProductDetailViewModel | BasketCalculatedLineViewModel[]
> & {
    quantity?: number;
};

export const mapToReserveInStore = (products: ReserveInStoreProducts, storeName?: string): Partial<ReserveInStore> => {
    if (!products) {
        return {};
    }

    return {
        reserved_items: Array.isArray(products)
            ? mapToTrackReserveInStoreLines(products)
            : [
                  {
                      reserved_item_id: products?.productNo || '',
                      reserved_item_name: products?.productName || '',
                      reserved_item_quantity: products?.quantity || 0,
                      reserved_price: products?.unitPriceRaw || 0
                  }
              ],
        ...(storeName ? { store: storeName } : {})
    };
};

export const mapToTrackReserveInStoreLines = (items: Partial<ReserveProductDetail[]> = []): ReserveInStoreLine[] =>
    (items || []).map(item => ({
        reserved_item_id: item?.variantNo || '',
        reserved_item_name: item?.productName || '',
        reserved_item_quantity: item?.quantity || 0,
        reserved_price: item?.unitPriceRaw || 0
    }));
